import { HOTEL_PENSION_TYPES } from '@/constants/hotelPension';
import { WEEKDAYS } from '@/constants/weekdays';
import type {
  HotelPensionPricingFormData,
  HotelPensionPricingPeriodFormData,
  HotelPensionPriceFormData,
} from '@/types/benefits/hotel/HotelPensionPricingSchema';

const PensionCardTypes = HOTEL_PENSION_TYPES.filter(
  (pensionType) => pensionType !== 'SingleRoom',
);

function buildEmptyPrices(): HotelPensionPriceFormData[] {
  return PensionCardTypes.map((pensionType) => ({
    pensionType,
    adultPrice: null as number | null,
    childPrice: null as number | null,
    adolescentPrice: null as number | null,
  }));
}

function buildEmptyPeriod(): HotelPensionPricingPeriodFormData {
  return {
    startDate: null as string | null,
    endDate: null as string | null,
    applicationDays: WEEKDAYS,
  };
}

export function buildEmptyPensionCard(): HotelPensionPricingFormData {
  return {
    name: '',
    periods: [buildEmptyPeriod()],
    prices: buildEmptyPrices(),
  };
}
